import { z } from 'zod';

export const BorrowerRequestedPayoffLoanStateExceptions = z.object({
  delinquent: z.boolean(),
  delinquentDays: z.int().positive(),
  activeForeclosure: z.boolean(),
  bankruptcy: z.boolean(),
});
export type BorrowerRequestedPayoffLoanStateExceptions = z.infer<typeof BorrowerRequestedPayoffLoanStateExceptions>;

export const BorrowerRequestedPayoffFee = z.object({
  title: z.string(),
  amount: z.number().positive(),
  appliedToEachProperty: z.boolean(),
});
export type BorrowerRequestedPayoffFee = z.infer<typeof BorrowerRequestedPayoffFee>;

export const BorrowerRequestedPayoffSettings = z.object({
  enabled: z.boolean(),
  loanStateExceptions: BorrowerRequestedPayoffLoanStateExceptions,
  fees: z.array(BorrowerRequestedPayoffFee),
});
export type BorrowerRequestedPayoffSettings = z.infer<typeof BorrowerRequestedPayoffSettings>;

export const DEFAULT_BORROWER_REQUESTED_PAYOFF_SETTINGS: BorrowerRequestedPayoffSettings = {
  enabled: false,
  loanStateExceptions: {
    delinquent: false,
    delinquentDays: 30,
    activeForeclosure: false,
    bankruptcy: false,
  },
  fees: [],
};

export const DEV_BORROWER_REQUESTED_PAYOFF_SETTINGS: BorrowerRequestedPayoffSettings = {
  ...DEFAULT_BORROWER_REQUESTED_PAYOFF_SETTINGS,
  enabled: true,
  fees: [
    {
      title: 'Willow Payoff Fee',
      amount: 1000,
      appliedToEachProperty: true,
    },
  ],
};
